import { v4 as uuidV4 } from 'uuid';
export const notTranslatedMessage = (message) => ({
    id: uuidV4(),
    defaultMessage: message,
});
